const binding = { modules: {}, dataActions: {} };

    (binding.modules['henrys'] = {
        c: () => require('partner/themes/henrys/henrys.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','content-block','header','hei-buybox','media-gallery','navigation-menu','promo-banner','text-block'],
        iNM: false,
        ns: '__local__',
        n: 'henrys',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'henrys.theme.settings.json',
        md: 'src/themes/henrys'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };